import { Component, OnInit } from '@angular/core';
import { CoreReviewCardRendererBaseComponent } from '../../shared/core-review-card-rendere-base.component';

@Component({
  selector: 'cu-card-review-fields',
  templateUrl: './card-review-fields.component.html'
})
export class CardReviewFieldsComponent extends CoreReviewCardRendererBaseComponent implements OnInit {
  ngOnInit() {}
}
